import { render, staticRenderFns } from "./indexSocial.vue?vue&type=template&id=09508eee&scoped=true"
import script from "./indexSocial.vue?vue&type=script&lang=js"
export * from "./indexSocial.vue?vue&type=script&lang=js"
import style0 from "./indexSocial.vue?vue&type=style&index=0&id=09508eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09508eee",
  null
  
)

export default component.exports